import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { confirmCompanyEmail } from "../../company/actions";
import { receiveNewEmail } from "../actions";

class ConfirmEmail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {confirmation_token: this.props.match.params.token},
      result: null,
      email: null,
    }

  }

  componentDidMount() {
    this.confirmCompanyEmail();
  }

  confirmCompanyEmail = () => {
    this.props.confirmCompanyEmail(this.state.data,
      response => {
        if(response.data.success) {
          this.setState({ result: 'success', email: response.data.email })
          this.props.receiveNewEmail(response.data.email)
        } else {
          this.setState({ result: response.data.error })
          this.props.receiveNewEmail(this.props.user.email)
        }
      }
    )
  }

  renderMessage = () => {
    if(!this.state.result) return null;

    if(this.state.result === 'success') {
      return(
        <div className="ds-container">
          <div className="grid">
            <div className="ds-card ds-fullPagePrompt">
              <div className="cardSection _eventPrompt">
                <i className="materialIcon --large -success">check_circle</i>
                <h1 className="subhead">Email Updated</h1>
                <p className="copy">{this.state.email}</p>
              </div>
              <a onClick={this.props.pushToUserProfile} className="ds-btn --full">Continue</a>
            </div>
          </div>
        </div>
      )
    } else {
      return(
        <div className="ds-container">
          <div className="grid">
            <div className="ds-card ds-fullPagePrompt">
              <div className="cardSection _eventPrompt">
                <i className="materialIcon --large">announcement</i>
                <h1 className="subhead">Email is not updated</h1>
                <p className="copy">
                  {this.state.result === 'link_has_expired_or_is_wrong' ? 'Link has expired or is wrong' : 'Something went wrong'}. Please contact customer support
                </p>
              </div>
              <a onClick={this.props.pushToUserProfile} className="ds-btn --full">Continue</a>
            </div>
          </div>
        </div>
      )
    }
  }

  render() {
    return this.renderMessage()
  }
}

const mapStateToProps = (state) => {
  return  {
    company_info: state.company,
    user: state.user,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return  {
    pushToUserProfile: (url) => dispatch(push('/user_profile')),
    confirmCompanyEmail: (body, callback) => dispatch(confirmCompanyEmail(body, callback)),
    receiveNewEmail: (email) => dispatch(receiveNewEmail({user: {email: email, new_email_temp: null}})),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);



// WEBPACK FOOTER //
// ./src/features/user/containers/ConfirmEmail.js